// Calendar-related type definitions

export enum CalendarConnectionState {
  DISCONNECTED = 'disconnected',
  CONNECTING = 'connecting',
  CONNECTED = 'connected',
  ERROR = 'error',
}

export interface CalendarState {
  connectionState: CalendarConnectionState;
  connectedProvider: 'google' | 'microsoft' | null;
  events: CalendarEvent[];
  lastSync?: Date;
  error?: string;
}

export interface CalendarEvent {
  id: string;
  title: string;
  startTime: Date;
  endTime: Date;
  attendees: Attendee[];
  meetingUrl?: string;
  location?: string;
  description?: string;
  recurrence?: RecurrencePattern;
  status: 'upcoming' | 'in-progress' | 'completed';
}

export interface Attendee {
  id: string;
  name: string;
  email: string;
  avatar?: string;
  status: 'accepted' | 'declined' | 'tentative' | 'pending';
}

export interface RecurrencePattern {
  frequency: 'daily' | 'weekly' | 'monthly' | 'yearly';
  interval: number;
  endDate?: Date;
  occurrences?: number;
}

export interface CalendarProvider {
  id: 'google' | 'microsoft';
  name: string;
  iconPath: string;
  authUrl: string;
  scopes: string[];
}

export interface CalendarConnection {
  id: string;
  userId: string;
  provider: CalendarProvider;
  accessToken: string;
  refreshToken: string;
  expiresAt: Date;
  createdAt: Date;
  lastSyncAt?: Date;
}

export interface CalendarSyncResult {
  success: boolean;
  eventsCount: number;
  lastSync: Date;
  error?: string;
}

export enum CalendarErrorType {
  AUTH_FAILED = 'auth_failed',
  NETWORK_ERROR = 'network_error',
  PERMISSION_DENIED = 'permission_denied',
  SYNC_FAILED = 'sync_failed',
  TOKEN_EXPIRED = 'token_expired',
}

export interface CalendarError {
  type: CalendarErrorType;
  message: string;
  retryable: boolean;
  provider?: 'google' | 'microsoft';
}

export interface CalendarProviders {
  google: Provider;
  microsoft: Provider;
}

export interface Provider {
  connected: boolean;
  email: string | null;
  login_link: string;
}
